<template>
    <div class="chart" ref="chartdiv" :style="{ width: props.width, height: props.height }"></div>
</template>

<script setup>
import { onMounted, onUnmounted, ref, defineProps } from 'vue';
import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';

const chartdiv = ref(null);
//props 데이터 추가
const props = defineProps({ chartData: { default: null }, colorFixed: { default: false }, width: { default: '100%' }, height: { default: '100%' } });
let root;
onMounted(() => {
    console.log('props colum   : ', props.chartData);
    if (props.chartData && props.chartData.length > 0) {
        root = am5.Root.new(chartdiv.value);

        // root.setThemes([am5themes_Animated.new(root)]);

        let chart = root.container.children.push(
            am5xy.XYChart.new(root, {
                // panX: false,
                // panY: false,
                // wheelX: "panX",
                // wheelY: "zoomX",
                paddingTop: 40,
                layout: root.verticalLayout,
            }),
        );

        // Define data
        let data = props.chartData;

        // Create Y-axis
        let yAxis = chart.yAxes.push(
            am5xy.ValueAxis.new(root, {
                // max: 110,
                // affectsMinMax: true,
                min: 0,
                max: 100,
                // numberFormat: "#'%'",
                renderer: am5xy.AxisRendererY.new(root, { minGridDistance: 50 }),
            }),
        );

        // Create X-Axis
        let xAxis = chart.xAxes.push(
            am5xy.CategoryAxis.new(root, {
                renderer: am5xy.AxisRendererX.new(root, { stroke: '#ccc', cellStartLocation: 0.2, cellEndLocation: 0.8 }), //colum간격
                categoryField: 'category',
                tooltip: am5.Tooltip.new(root, {}),
            }),
        );

        xAxis.get('renderer').labels.template.setAll({
            fontSize: '2.1vmin', // x좌표 폰트 크기
            fill: '#424242', // x좌표 폰트 색상
            paddingTop: 15,
            fontWeight: 550,
        });

        yAxis.get('renderer').labels.template.setAll({
            paddingRight: 16,
            fontSize: '2vmin', // y좌표 폰트 크기
            fill: '#616161', // y좌표 폰트 색상
            fontWeight: 550,
        });

        xAxis.data.setAll(data);
        //진단평가 시 표출 x
        if (props.chartData[0].value1) {
            // Create series1 (before)
            let series1 = chart.series.push(
                am5xy.ColumnSeries.new(root, {
                    name: 'Series',
                    xAxis: xAxis,
                    yAxis: yAxis,
                    valueYField: 'value1',
                    categoryXField: 'category',
                    maskBullets: false,
                    // tooltip: am5.Tooltip.new(root, {
                    //     labelText: "{valueY}%",
                    //     fill: am5.color(0xff5566)
                    // }),
                    fill: 'red',
                }),
            );
            series1.columns.template.setAll({
                fillOpacity: 0.5,
                strokeWidth: 2,
                width: 30,
                cornerRadiusTL: 30,
                cornerRadiusTR: 30,
            });
            series1.columns.template.adapters.add('fill', (fill, target) => {
                // const value = target.dataItem.dataContext.value1;

                fill = '#ccc';

                return fill;
            });
            series1.columns.template.adapters.add('stroke', (stroke, target) => {
                // const value = target.dataItem.dataContext.value1;

                stroke = '#ccc';

                return stroke;
            });
            series1.data.setAll(data);
            // 이전 차트 %
            series1.bullets.push(function () {
                return am5.Bullet.new(root, {
                    // locationY: 0.0,
                    locationY: 1.0,
                    sprite: am5.Label.new(root, {
                        text: "[fontWeight:700]{valueYWorking.formatNumber('#.')}%",
                        // fill: root.interfaceColors.get("alternativeText"),
                        centerY: am5.p100,
                        centerX: am5.p50,
                        populateText: true,
                        fill: 'black',
                        fontSize: '2vmin',
                    }),
                });
            });
            series1.appear(2000);
        }
        //create series2 (now)
        let series2 = chart.series.push(
            am5xy.ColumnSeries.new(root, {
                name: 'Series',
                xAxis: xAxis,
                yAxis: yAxis,
                valueYField: 'value2',
                categoryXField: 'category',
                maskBullets: false,
                // tooltip: am5.Tooltip.new(root, {
                //     labelText: "{valueY}%",
                //     fill: am5.color(0xff5566)
                // }),
                fill: 'red',
            }),
        );
        series2.columns.template.setAll({
            fillOpacity: 0.5,
            strokeWidth: 2,
            width: 30,
            cornerRadiusTL: 30,
            cornerRadiusTR: 30,
        });
        //차트 fill색상
        series2.columns.template.adapters.add('fill', (fill, target) => {
            const value = target.dataItem.dataContext.value2;
            if (props.colorFixed) {
                fill = '#18b73f';
            } else {
                if (value < 50) {
                    fill = '#A0A0A0';
                } else if (value >= 50 && value < 80) {
                    fill = '#bee8c9';
                } else {
                    fill = '#18b73f';
                }
            }
            return fill;
        });
        //차트 stroke색상
        series2.columns.template.adapters.add('stroke', (stroke, target) => {
            const value = target.dataItem.dataContext.value2;
            if (props.colorFixed) {
                stroke = '#18b73f';
            } else {
                if (value < 50) {
                    stroke = '#A0A0A0';
                } else if (value >= 50 && value < 80) {
                    stroke = '#bee8c9';
                } else {
                    stroke = '#18b73f';
                }
            }
            return stroke;
        });
        series2.data.setAll(data);
        // 현재 차트 &
        series2.bullets.push(function () {
            return am5.Bullet.new(root, {
                // locationY: 0.0,
                locationY: 1.0,
                sprite: am5.Label.new(root, {
                    text: "[fontWeight:700]{valueYWorking.formatNumber('#.')}%",
                    // fill: root.interfaceColors.get("alternativeText"),
                    centerY: am5.p100,
                    centerX: am5.p50,
                    populateText: true,
                    fill: props.colorFixed ? '#18b73f' : 'black',
                    fontSize: '2vmin',
                }),
            });
        });
        series2.appear(2000);
        // series2.appear(1500);
        chart.appear(1000, 100);
    }
    // let series2 = chart.series.push(
    //     am5xy.ColumnSeries.new(root, {
    //         name: "Series",
    //         xAxis: xAxis,
    //         yAxis: yAxis,
    //         valueYField: "value2",
    //         categoryXField: "category"
    //     })
    // );
    // series2.data.setAll(data);

    // Add legend
    // let legend = chart.children.push(am5.Legend.new(root, {}));
    // legend.data.setAll(chart.series.values);

    // Add cursor
    // chart.set('cursor', am5xy.XYCursor.new(root, {}));

    // var tooltip = am5.Tooltip.new(root, {
    //     getFillFromSprite: false,
    //     getStrokeFromSprite: true,
    //     autoTextColor: false,
    //     getLabelFillFromSprite: true,
    //     labelText: '{valueY}%',
    //     fontSize: '1.2vmin',
    // });

    // tooltip.get('background').setAll({
    //     fill: 'white',
    //     fillOpacity: 0.8,
    // });

    // series1.set('tooltip', tooltip);
    // let activeState = polygonTemplate.states.create("active");
    // activeState.properties.fill = chart.colors.getIndex(4);

    // // Create an event to toggle "active" state
    // polygonTemplate.events.on("hit", function (ev) {
    //     ev.target.isActive = !ev.target.isActive;
    // })

    // Make stuff animate on load
});

onUnmounted(() => {
    root.dispose();
});
</script>

<!-- scss로 전환 -->
<style scoped lang="scss">
@media print {
    //pc 추가
    @media all and (min-width: 1201px) {
        .chart {
            ::v-deep > div {
                display: flex;
                justify-content: center;
            }
            ::v-deep canvas {
                width: 110% !important;
                height: 110% !important;
                top: 60% !important;
                left: 50% !important;
                transform: translate(-50%, -50%);
            }
        }
    }
    //tablet 추가
    @media all and (max-width: 1200px) {
        .chart {
            ::v-deep > div {
                display: flex;
                justify-content: center;
            }
            ::v-deep canvas {
                width: 110% !important;
                height: 120% !important;
                top: 50% !important;
                left: 50% !important;
                transform: translate(-50%, -50%);
            }
        }
    }
}
</style>
